import { Button } from 'ui/button';
import { BUTTON_SIZES } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import noop, { NoOp } from 'utils/noop';
import { ModalType, useModalContext } from '../../context';
import { ScheduleFormState } from '../../types';
import {
  CONFIRM_SCHEDULE_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID,
  CONFIRM_SCHEDULE_CAMPAIGN_MODAL_TEST_ID,
} from './ConfirmScheduleCampaignModal.constants';
import { ConfirmScheduleCampaignContent } from './ConfirmScheduleCampaignContent';

export type ConfirmScheduleCampaignModalProps = {
  values?: ScheduleFormState;
  onConfirm?: NoOp;
};

export const ConfirmScheduleCampaignModal = ({
  onConfirm = noop,
  values,
}: ConfirmScheduleCampaignModalProps) => {
  const { closeModal } = useModalContext();

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.ConfirmScheduleCampaign)}
      id={CONFIRM_SCHEDULE_CAMPAIGN_MODAL_TEST_ID}
      data-test={CONFIRM_SCHEDULE_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>Confirm schedule?</ModalHeader>
      <ModalBody>
        <ConfirmScheduleCampaignContent values={values as ScheduleFormState} />
      </ModalBody>
      <ModalFooter cancelLabel="Cancel">
        <Button
          onClick={onConfirm}
          size={BUTTON_SIZES.LARGE}
          data-test={CONFIRM_SCHEDULE_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID}
        >
          Confirm schedule
        </Button>
      </ModalFooter>
    </Modal>
  );
};
